import React, { Component } from 'react';
import config from 'react-global-configuration';
import RequestApi from '../Miscelania/RequestApi';

import { Modal } from 'react-bootstrap';

import InputMask from 'react-input-mask';
import getLocale from '../../i18n/getLocale';


class PaymentRequestLeg extends Component {
  // constructor
  constructor(props) {
    super(props);

    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'closed',
      },
      redirect_url: false,
      loaded: 0,
      modal: false,
      leg_index: this.props.leg_index,
      zipcode_bases: this.props.zipcode_bases,
      zipcode_suppliers: this.props.zipcode_suppliers,
      origin_base_id: this.props.data.origin_base_id,
      origin_supplier_id: this.props.data.origin_supplier_id,
      origin_base: this.props.data.origin_base,
      origin_supplier: this.props.data.origin_supplier,
      zipcode_origin: this.props.data.zipcode_origin,
      destination_base_id: this.props.data.destination_base_id,
      destination_supplier_id: this.props.data.destination_supplier_id,
      destination_base: this.props.data.destination_base,
      destination_supplier: this.props.data.destination_supplier,
      zipcode_destination: this.props.data.zipcode_destination,
    };
    //Handlers
    this.handleAlert = this.handleAlert.bind(this);
    this.handleLoaded = this.handleLoaded.bind(this);
    this.handleMessage = this.handleMessage.bind(this);

    this.chooseLocation = this.chooseLocation.bind(this);

    this.locale = getLocale();
  }
  // Handlers
  handleChange (name, event) {
    this.props.handleChangeLegData(name, event.target.value, this.state.leg_index);
  }


  handleAlert(message, type, status, mode) {
    if(mode === 'reset') {
      this.setState({overlay: {message: '', type: '', status: 'closed'}});
    } else {
      this.setState({overlay: {message: message, type: type, status: status}});
    }
  }
  handleMessage () {
    var message = localStorage.getItem("verify_message");
    if (message !== null && typeof message !== 'undefined') {
      message = JSON.parse(message);
      var self = this;
      self.setState({overlay: {message: message.alert_message, type: message.alert_type, status: 'open'}});
      localStorage.removeItem("verify_message");
    }
  }
  handleLoaded(state) {
    if(this.state.loaded !== 2) {
      this.setState({loaded: state});
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if(this.state.loaded === 1 && prevState.loaded === 0) {
      this.setState({loaded: 2}, this.loadData());
    }
  }

  // LM
  componentWillReceiveProps(newProps) {
    this.setState({
      leg_index: newProps.leg_index,
      zipcode_bases: newProps.zipcode_bases,
      zipcode_suppliers: newProps.zipcode_suppliers,
      origin_base_id: newProps.data.origin_base_id,
      origin_supplier_id: newProps.data.origin_supplier_id,
      origin_base: newProps.data.origin_base,
      origin_supplier: newProps.data.origin_supplier,
      zipcode_origin: newProps.data.zipcode_origin,
      destination_base_id: newProps.data.destination_base_id,
      destination_supplier_id: newProps.data.destination_supplier_id,
      destination_base: newProps.data.destination_base,
      destination_supplier: newProps.data.destination_supplier,
      zipcode_destination: newProps.data.zipcode_destination,
    });
  }

  chooseLocation(id, zipcode, name, type, source) {
    this.props.resetLeg(type, this.state.leg_index);
    var location = type + '_' + + '_id';
    var type_id = type + '_' + source + '_id';
    this.props.handleChangeLegData((type + '_' + source), name, this.state.leg_index);
    this.props.handleChangeLegData((type + '_' + source + '_id'), id, this.state.leg_index);
    this.props.handleChangeLegData(('zipcode_' + type), zipcode, this.state.leg_index);
  }

  render() {
    var self = this;
    return (
<tr>
    <td className="text-center">
      {(parseInt(this.state.leg_index)+1)}
    </td>
    <td>
      <button type="button" className="btn btn-block btn-success" onClick={() => this.setState({modal: true})}><i className="fa fa-fw fa-search"></i> {this.locale.Pagamentos.Bases.botaoLocalidades}</button>
    </td>
    <td>
      <div className="form-group">
        <input value={this.state.origin_base} mask="99999-999" className="form-control" disabled />
      </div>
    </td>
    <td>
      <div className="form-group">
        <input value={this.state.origin_supplier} mask="99999-999" className="form-control" disabled />
      </div>
    </td>
    <td>
      <div className="form-group">
        <InputMask value={this.state.zipcode_origin} required maskChar={null} name="zipcode_origin" mask="99999-999" className="form-control" onChange={this.handleChange.bind(this, 'zipcode_origin')} placeholder="XXXXX-XXX" />
      </div>
    </td>
    <td>
      <div className="form-group">
        <input value={this.state.destination_base} mask="99999-999" className="form-control" disabled />
      </div>
    </td>
    <td>
      <div className="form-group">
        <input value={this.state.destination_supplier} mask="99999-999" className="form-control" disabled />
      </div>
    </td>
    <td>
      <div className="form-group">
        <InputMask value={this.state.zipcode_destination} required maskChar={null} name="zipcode_destination" mask="99999-999" className="form-control" onChange={this.handleChange.bind(this, 'zipcode_destination')} placeholder="XXXXX-XXX" />
      </div>
    </td>
    <td>
      <button type="button" className="btn btn-danger btn-block" onClick={() => this.props.removeLeg(this.state.leg_index)}><i className="fa fa-fw fa-close"></i></button>
    </td>

  <Modal show={this.state.modal} bsSize={'large'} aria-labelledby="contained-modal-title-lg">
    <Modal.Header>
      <h4 className="pull-left">{this.locale.Pagamentos.Bases.titulo}</h4>
      <button className="btn btn-danger btn-sm pull-right" onClick={()=>this.setState({ modal: false })}>
      <i className="fa fa-fw fa-close"></i></button>
      <div className="clearfix"></div>
    </Modal.Header>
    <Modal.Body>
      <div className="table-responsive">
        <table className="table table-bordered table-stripped table-hover">
          <thead>
            <tr>
              <th className="text-center">{this.locale.Pagamentos.Bases.tabela.Nome}</th>
              <th className="text-center">{this.locale.Pagamentos.Bases.tabela.Tipo}</th>
              <th className="text-center">{this.locale.Pagamentos.Bases.tabela.CEP}</th>
              <th className="text-center"></th>
              <th className="text-center"></th>
            </tr>
          </thead>
          <tbody id="suppliers-certifications">
            {Object.keys(this.state.zipcode_bases).map(function(k) {
              return (
                <tr>
                  <td className="text-center">{self.state.zipcode_bases[k]['name']}</td>
                  <td className="text-center">{self.locale.Pagamentos.Bases.tabela.Base}</td>
                  <td className="text-center">{self.state.zipcode_bases[k]['zipcode']}</td>
                  <td className="text-center">
                    <button onClick={() => self.chooseLocation(self.state.zipcode_bases[k]['id'], self.state.zipcode_bases[k]['zipcode'], self.state.zipcode_bases[k]['name'], 'origin', 'base')} className="btn btn-primary btn-block">{self.locale.Pagamentos.Bases.tabela.botaoAssociarCEPAOrigem}</button>
                  </td>
                  <td className="text-center">
                    <button onClick={() => self.chooseLocation(self.state.zipcode_bases[k]['id'], self.state.zipcode_bases[k]['zipcode'], self.state.zipcode_bases[k]['name'], 'destination', 'base')} className="btn btn-primary btn-block">{self.locale.Pagamentos.Bases.tabela.botaoAssociarCEPADestino}</button>
                  </td>
                </tr>
              );
            })}
            {Object.keys(this.state.zipcode_suppliers).map(function(k) {
              return (
                <tr>
                  <td className="text-center">{self.state.zipcode_suppliers[k]['name']}</td>
                  <td className="text-center">{self.locale.Pagamentos.Bases.tabela.Fornecedor}</td>
                  <td className="text-center">{self.state.zipcode_suppliers[k]['zipcode']}</td>
                  <td className="text-center">
                    <button onClick={() => self.chooseLocation(self.state.zipcode_suppliers[k]['id'], self.state.zipcode_suppliers[k]['zipcode'], self.state.zipcode_suppliers[k]['name'], 'origin', 'supplier')} className="btn btn-primary btn-block">{self.locale.Pagamentos.Bases.tabela.botaoAssociarCEPAOrigem}</button>
                  </td>
                  <td className="text-center">
                    <button onClick={() => self.chooseLocation(self.state.zipcode_suppliers[k]['id'], self.state.zipcode_suppliers[k]['zipcode'], self.state.zipcode_suppliers[k]['name'], 'destination', 'supplier')} className="btn btn-primary btn-block">{self.locale.Pagamentos.Bases.tabela.botaoAssociarCEPADestino}</button>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </Modal.Body>
    <Modal.Footer>
      <button className="btn btn-danger btn-sm pull-right" onClick={()=>this.setState({ modal: false })}>
      <i className="fa fa-fw fa-close"></i></button>
    </Modal.Footer>
  </Modal>
</tr>
    );
  }
}

export default PaymentRequestLeg;



// WEBPACK FOOTER //
// ./src/Components/Payments/PaymentRequestLegs.js